module.exports = __webpack_public_path__ + "img/01_02sozai1.f08a54ea.png";